// extracted by mini-css-extract-plugin
module.exports =  {"container":"jsaV5fMXaS_IVD6po31z"};